<script lang="ts" module>
	export const DEV_TURNSTILE_TOKEN = "dev-turnstile-bypass";
</script>

<script lang="ts">
	import { dev } from "$app/env";
	import { PUBLIC_TURNSTILE_SITE_KEY } from "$app/env/public";
	import { turnstile } from "@svelte-put/cloudflare-turnstile";
	import { toast } from "svelte-sonner";

	let { token = $bindable(), class: className }: { token: string | undefined; class?: string } =
		$props();

	let widgetId: string | undefined;

	function rearmToken() {
		if (token) return;
		if (dev) token = DEV_TURNSTILE_TOKEN;
		else if (widgetId) window.turnstile?.reset(widgetId);
	}

	rearmToken();
	$effect(rearmToken);
</script>

<input type="hidden" name="turnstileToken" bind:value={token} />
{#if !dev}
	<div
		use:turnstile
		turnstile-sitekey={PUBLIC_TURNSTILE_SITE_KEY}
		turnstile-theme="auto"
		turnstile-size="normal"
		onturnstile={(e) => {
			widgetId = e.detail.widgetId;
			token = e.detail.token;
		}}
		onturnstileerror={(e) => {
			console.error("Turnstile error:", e.detail.code);
			toast.error("Verification failed. Please refresh and try again.");
		}}
		class={className}
	></div>
{/if}
